import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Menu, IconButton } from '@mui/material';
import clsx from 'clsx';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ActionMenuItem from './ActionMenuItem';
import styles from './ActionMenu.module.scss';

const ActionMenu = ({ removeNotification, markNotificationRead, ...restProps }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const markNotification = () => {
    markNotificationRead();
    handleClose();
  };
  const deleteNotification = () => {
    removeNotification();
    handleClose();
  };

  const StyledMenu = styled((props) => (
    <Menu
      id="company-info-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'menu-button',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
      '& .MuiMenu-list': {},
    },
  }));

  return (
    <>
      <IconButton
        id="menu-button"
        className={clsx(styles.menuBtn, restProps?.btnClassName)}
        aria-controls={open ? 'company-info-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        type="button"
        onClick={handleClick}
      >
        <MoreVertIcon width={4} height={16} sx={{ color: open ? '#143471' : '#212121' }} />
      </IconButton>
      <StyledMenu>
        <ActionMenuItem
          onClick={handleClose}
          text="Don't show this notification"
          icon="/images/templates/eye-icon-off.svg"
          iconWidth={20}
          iconHeight={20}
        />
        <ActionMenuItem
          onClick={markNotification}
          text="Mark as read"
          icon="/images/templates/check-icon.svg"
          iconWidth={20}
          iconHeight={20}
        />
        <ActionMenuItem
          onClick={deleteNotification}
          text="Delete"
          icon="/images/templates/delete-red-icon.svg"
          iconWidth={20}
          iconHeight={20}
        />
      </StyledMenu>
    </>
  );
};

export default ActionMenu;
